import React, { useEffect } from "react";
import DashboardCard from "../../components/ui/dashboardCard";
import AutoGeneratePassword from "../../components/autoGeneratePassword";
import { CheckBoxForm } from "../../components/forms/checkBoxForm";
import { PrimaryButton, SecondaryButton } from "../../components/buttons/buttons";
import { resetResetPasswordAccManagerState } from "../../redux/accountManager/accountManagerSlice";
import successToast from "../../utils/successToast";
import errorToast from "../../utils/errorToast";
import { useSelector } from "react-redux";
import { SubmitHandler, useForm } from "react-hook-form";
import { RootState, useAppDispatch } from "../../redux/store";
import UserAuditDetails from "../../utils/userAuditDetails";
import DetectDevice from "../../utils/detectDevice";
import { AccessTokenDecoder } from "../../utils/accessTokenDecoder";
import { ResponseType } from "../../modals/IreduxResponse";
import DefaultImage from "../../assests/images/default-profile.jpg";
import { resetPasswordHospital } from "../../redux/addHospital/hospitalManagementReducer";
import { resetResetPasswordHospitalState } from "../../redux/addHospital/hospitalManagementSlice";

type ModalProps = {
    isVisible: boolean;
    onClose: () => void;
    onClick?: () => void;
    data: {
        name?: string;
        hospitalId?: string | null;
        photo?: string;
        email?: string | undefined
        userId?: number | undefined;
        userName?: string | undefined;
        phone?: string | undefined;
        role?: string | undefined;
    };
};

const ForgotPasswordHospital: React.FC<ModalProps> = ({
    isVisible,
    onClose,
    onClick,
    data,
}) => {
    const dispatch = useAppDispatch();


    const {
        handleSubmit,
        control,
        watch,
        setValue,
        reset,
        clearErrors,
        formState: { errors },
    } = useForm<any>();



    const resetHospitalState = useSelector(
        (state: RootState) => state.resetPasswordHospital
    );

    const onSubmit: SubmitHandler<any> = async (value) => {

        dispatch(
            resetPasswordHospital({
                email: data?.email?.toLowerCase(),
                password: value?.password,

                isTempPassword: value?.setNewPAssword,
            })
        );
    };

    useEffect(() => {
        if (resetHospitalState?.status === "success") {
            successToast("Password Reset Successfully");
            reset();
            onClose();
        } else if (resetHospitalState?.status === "failed") {
            if (resetHospitalState?.error?.status === 503) {
                successToast("Password Reset Successfully");
                reset();
                onClose();
            } else {
                errorToast(
                    resetHospitalState?.error?.response?.data?.message ??
                    resetHospitalState?.error?.data?.message ??
                    resetHospitalState?.error?.message ??
                    "Something Went Wrong"
                );


            }
        }
    }, [resetHospitalState]);

    useEffect(() => {
        if (!isVisible) {

            dispatch(resetResetPasswordHospitalState());

        }
    }, [isVisible]);


    if (!isVisible) return null;

    return (
        <DashboardCard>
            <div className="w-100 py-5 px-5">
                <div className="text-center">
                    <span className="text-primary text-24 font-semibold">
                        Reset Password
                    </span>
                </div>

                <div className="flex mt-4 bg-blue-150 p-3 items-center rounded">
                    <div className="w-[40px] h-[40px] flex items-center">
                        <img
                            src={data?.photo ? data?.photo : DefaultImage}
                            className="w-[100%] h-[100%] object-contain rounded-full"
                            alt="User"
                        />
                    </div>
                    <div className="flex flex-col ps-6">
                        <span className="text-primary text-16 font-semibold">
                            {data.name}
                        </span>
                        <span className="text-secondary text-12 font-medium">
                            Hospital ID: {data.hospitalId}
                        </span>
                    </div>
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div>
                        <AutoGeneratePassword
                            name="password"
                            control={control}
                            setValue={setValue}
                            title={false}
                            clearErrors={clearErrors}
                            errors={errors}
                            disabled={resetHospitalState?.isLoading}
                        />
                    </div>

                    <div className="mt-5">
                        <CheckBoxForm
                            label="Set a new password after logging in"
                            id="setNewPAssword"
                            type="checkbox"
                            control={control}
                            required={false}
                            defaultValue={false}
                            disabled={resetHospitalState?.isLoading}
                        />
                    </div>

                    <div className="flex justify-around mt-5 gap-5">
                        <SecondaryButton
                            padding="py-3 px-14"
                            type="button"
                            name="Cancel"
                            onClick={() => {
                                onClose();
                                reset();
                            }}
                        />
                        <PrimaryButton
                            padding={
                                resetHospitalState?.isLoading
                                    ? "py-3 px-8"
                                    : "py-3 px-16"
                            }
                            type="submit"
                            name="Save"
                            loading={resetHospitalState?.isLoading}
                        />
                    </div>
                </form>
            </div>
        </DashboardCard>
    );
};

export default ForgotPasswordHospital;
